import React from 'react';

import { lumappsJourney } from '@lumapps/lumx/custom-icons';
import { NavigationItemType, NavigationMapItem } from '@lumapps/navigation/types';
import { GlobalPickerOption } from '@lumapps/pickers/components/GlobalPickerOption';
import { useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationItemWizardOptionProps } from '../../types';
import { generateNewNodeBase } from '../../utils';
import { SystemPageNavigationItemModal } from '../NavigationItemModal/SystemPageNavigationItemModal';

export const JourneyWizardOption: React.FC<NavigationItemWizardOptionProps> = ({
    languages,
    defaultLanguage,
    onAdded,
    setWasOptionSelected,
    isOpen = false,
    scope,
    isDisabled,
    optionProps = {},
    navigationItemModalProps,
}) => {
    const { translateKey } = useTranslate();
    const [isModalOpen, setIsOpenModal] = React.useState<boolean>(isOpen);
    const ref = React.useRef(null);

    const onSave = (navItem: NavigationMapItem) => {
        onAdded(navItem);
    };

    return (
        <>
            <GlobalPickerOption
                icon={lumappsJourney}
                name={translateKey(NAVIGATION_ADMIN.JOURNEY)}
                description={translateKey(NAVIGATION_ADMIN.JOURNEY_DESCRIPTION)}
                itemRef={ref}
                isDisabled={isDisabled}
                scope={scope}
                id="journeys"
                onClick={() => {
                    setIsOpenModal(true);
                    setWasOptionSelected(true);
                }}
                {...optionProps}
            />
            {isModalOpen && (
                <SystemPageNavigationItemModal
                    isOpen={isModalOpen}
                    languages={languages}
                    defaultLanguage={defaultLanguage}
                    onSave={onSave}
                    buttonRef={ref}
                    scope={scope}
                    navigationItem={generateNewNodeBase({
                        type: NavigationItemType.SYSTEM_PAGE,
                        systemPageReference: {
                            type: NavigationItemType.JOURNEYS,
                        },
                        children: [],
                    })}
                    onClose={() => {
                        setIsOpenModal(false);
                        setWasOptionSelected(false);
                    }}
                    navigationItemModalProps={navigationItemModalProps}
                />
            )}
        </>
    );
};
